import { StateMap } from './StateMap.type'
import { getDefaultStateMapDisk } from './getDefaultStateMapDisk'

export default function createDefaultStateMap(): StateMap {
  return {
    id: null,
    dname: null,
    bio: null,
    disk: getDefaultStateMapDisk(),
  }
}
